import { Injectable, Injector, inject } from '@angular/core';
import { WebApplicationConfigurationService } from '@app/shared/services/web-application-configuration.service';
import { SignalCache, createSignalCache } from '@app/shared/utils/signal-cache';
import { Observable } from 'rxjs';

/*
 * This service is design to synchronize the MarkdownRenderer with the async call to get getPropertyValue()
 * PLEASE STICK TO THIS PURPOSE
 */
@Injectable({ providedIn: 'root' })
export class MarkdownWebApplicationConfigurationService {
  // Services
  private webApplicationConfigurationService = inject(WebApplicationConfigurationService);
  private injector = inject(Injector);

  // Properties — signal-backed cache (was ReplaySubject<string>(1))
  private readonly _linkTargetSelfUrlpattern: SignalCache<string> = createSignalCache<string>(this.injector);

  constructor() {
    this.webApplicationConfigurationService.getPropertyValue('ui.markdown.link.target.self.urlpattern').subscribe((value) => {
      this._linkTargetSelfUrlpattern.sig.set(value ?? '');
    });
  }

  public get linkTargetSelfUrlpattern(): Observable<string> {
    return this._linkTargetSelfUrlpattern.obs$;
  }
}
